import "./styles.css";

export default function Button({ children, onClick, type = "button", disabled = false, className = "", ...props }) {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`btn ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}
